import { Button, Checkbox, Form, Input, Space } from "antd";
import CustomModal from "../../../../components/ui/CustomModal";
import { ModalComponentProps } from "../../../../types";

export default function CreateGroupModal({
  handleClose,
  data,
  type,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {};

  const features = Array(6).fill("Feature's title");
  const modules = Array(7).fill("Module Title");

  return (
    <CustomModal
      //   title=""
      title="Create User Group"
      {...rest}
      handleClose={handleClose}
      width={900}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            name=""
            label="Group Name"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please enter a Group Name",
              },
            ]}
          >
            <Input size="large" placeholder="Enter group title" />
          </Form.Item>
          <Form.Item
            name=""
            label="Group Role Name"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please enter a Group Role Name",
              },
            ]}
          >
            <Input size="large" placeholder="Enter role name" />
          </Form.Item>
        </div>

        <div className="w-full px-3 py-1.5 bg-[#f0f3f8] rounded-md justify-between items-center flex">
          <div className="items-center gap-4 flex">
            <div className="text-display-body text-lg font-semibold leading-[30px]">
              Permission Access
            </div>

            <Form.Item className="mb-0">
              <Checkbox>
                {" "}
                <p className="text-[#4a71ff] text-sm font-medium leading-normal">
                  Select All
                </p>
              </Checkbox>
            </Form.Item>
          </div>
          <div className="text-[#fe7235] text-sm font-medium leading-normal">
            Unselect
          </div>
        </div>

        <div className="border border-gray-100 mt-4">
          {modules.map((module, rowIndex) => (
            <div key={rowIndex} className="flex border-b border-gray-100">
              <div className="w-40 p-2 font-semibold border-r border-gray-100 flex items-center bg-[#FFF5F4]">
                {module}
              </div>
              <div className="grid grid-cols-6 flex-1">
                {features.map((feature, colIndex) => (
                  <div
                    key={`${rowIndex}-${colIndex}`}
                    className="p-2 border-r border-gray-300 flex items-center gap-2"
                  >
                    <Checkbox />
                    <span className="text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
          >
            Create
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
